import type { AxonEventData, Response, Message } from './common';

/**
 * ## @visiba/axon
 */
export namespace ConvertMessageData {
	/**
	 * Converts an socket event to an readable message.
	 */
	export function read(data: string): Response {
		const { C, T, D, I } = JSON.parse(data) as AxonEventData;

		return {
			controller: C,
			topic: T,
			data: D,
			id: I,
		};
	}

	/**
	 * Constructs a string to publish on the web socket.
	 */
	export function write({ controller, topic, data, id }: Message): string {
		const builder: Partial<AxonEventData> = {
			C: controller,
			T: topic,
		};
		if (data) builder['D'] = JSON.stringify(data);
		if (id) builder['I'] = id;

		return JSON.stringify(builder);
	}
}
